const FLYOUT_BASKET_CLASS_NAME = 'blaze-ecommerce-flyout-basket';
const TOTAL_TEXT_CLASS = 'blaze-ecommerce-flyout-basket__total__total-text';
const ICON_VARIANT_CLASS = 'blaze-ecommerce-flyout-basket__icon-variant';
const ICON_VARIANT_TOTAL_CLASS = 'blaze-ecommerce-flyout-basket__icon-variant__total';
const TARGET_CLASSES = [TOTAL_TEXT_CLASS, ICON_VARIANT_CLASS, ICON_VARIANT_TOTAL_CLASS];

export { FLYOUT_BASKET_CLASS_NAME, TOTAL_TEXT_CLASS, TARGET_CLASSES };
